import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import DiarioList from "@/pages/DiarioList";
import DiarioDetail from "@/pages/DiarioDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/diario" element={<DiarioList />} />
          <Route path="/diario/:slug" element={<DiarioDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#cd2e2e",
            color: "#ffffd7",
            border: "none",
            borderRadius: "999px",
            fontFamily: "Quicksand, sans-serif",
            fontWeight: 600,
            padding: "14px 22px",
          },
        }}
      />
    </div>
  );
}

export default App;
